<template>
  <g clip-path="url(#clip0_67_14399)">
    <path
      d="M1.20447 4.85967C0.931842 4.6996 0.931843 4.3004 1.20447 4.14033L8.1608 0.055929C8.2941 -0.0223397 8.45942 -0.0181882 8.58874 0.0666751L14.8128 4.15107C15.0624 4.31485 15.0624 4.68515 14.8128 4.84893L8.58874 8.93332C8.45942 9.01819 8.2941 9.02234 8.1608 8.94407L1.20447 4.85967Z"
    />
    <path
      d="M9 10.1743C9 10.03 9.06684 9.89515 9.17812 9.81507L14.3781 6.07324C14.6439 5.88196 15 6.08764 15 6.43248V12.1018C15 12.2394 14.9393 12.3687 14.8365 12.45L9.63655 15.9156C9.37234 16.1248 9 15.9211 9 15.5675V10.1743Z"
    />
    <path
      d="M1 11.8205C1 11.9712 1.06619 12.1107 1.17399 12.1872L7.5 16.0002C7.73528 16.167 8.03189 15.9625 8.03189 15.6335V10.2393C8.03189 10.0886 7.9657 9.94909 7.8579 9.87265L1.53189 6.05962C1.29661 5.89279 1 6.09727 1 6.4263V11.8205Z"
    />
  </g>
  <defs>
    <clipPath id="clip0_67_14399">
      <rect width="16" height="16" fill="white" />
    </clipPath>
  </defs>
</template>
